// ──────────────────────────────────────────────────────────────────────────
// DiarioStatistiche.js — Container della pagina Statistiche del Diario.
//
// Aggiunge:
//   - Provider del Context filtri (StatisticheFiltriProvider)
//   - Barra filtri condivisi sopra ai sotto-tab (DiarioStatisticheFiltri)
//   - Barra di navigazione con i sotto-tab
//
// Refactor v131 sub-deploy 3:
//   - Sotto-tab "🎯 Per sistema" RIMOSSO (decisione utente: il Diario
//     Operativo deve restare uno strumento snello). L'analisi profonda
//     per sistema confluirà nella futura pagina Statistiche generali (TASK 5).
//   - Restano 3 sotto-tab: Sintesi · Matrici P/L · Confronto stagioni.
//
// Il file DiarioStatistichePerSistema.js resta in repo per ora ma non
// viene più importato; può essere recuperato in futuro per TASK 5.
// ──────────────────────────────────────────────────────────────────────────

import { useState } from "react";
import { StatisticheFiltriProvider } from "../contexts/StatisticheFiltriContext";
import DiarioStatisticheFiltri from "./DiarioStatisticheFiltri";
import DiarioStatisticheSintesi from "./DiarioStatisticheSintesi";
import DiarioStatisticheMatrice from "./DiarioStatisticheMatrice";
import DiarioStatisticheConfrontoStagioni from "./DiarioStatisticheConfrontoStagioni";

const FONT = "'DM Sans', sans-serif";

const SOTTO_TAB = [
  { id: "sintesi",   label: "📊 Sintesi" },
  { id: "matrici",   label: "📋 Matrici P/L" },
  { id: "confronto", label: "🔄 Confronto stagioni" },
];

const KEY_STORAGE_TAB = "diario_statistiche_sottotab_attivo";

function leggiSottoTabAttivo() {
  try {
    const v = sessionStorage.getItem(KEY_STORAGE_TAB);
    if (v && SOTTO_TAB.some(t => t.id === v)) return v;
  } catch {}
  return "sintesi";
}

function BarraSottoTab({ attivo, onChange }) {
  return (
    <div style={{
      display: "flex", gap: 4,
      borderBottom: "1px solid #E2E8F0",
      marginBottom: 12, marginTop: 4,
      flexWrap: "wrap",
    }}>
      {SOTTO_TAB.map(t => {
        const att = attivo === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            style={{
              fontFamily: FONT, fontSize: 13, fontWeight: att ? 600 : 500,
              background: "transparent",
              color: att ? "#2563EB" : "#64748B",
              border: "none",
              borderBottom: att ? "2px solid #2563EB" : "2px solid transparent",
              padding: "8px 14px", marginBottom: -1,
              cursor: "pointer",
            }}
          >{t.label}</button>
        );
      })}
    </div>
  );
}

export default function DiarioStatistiche() {
  const [sottoTabAttivo, setSottoTabAttivo] = useState(leggiSottoTabAttivo);

  const cambiaSottoTab = (id) => {
    setSottoTabAttivo(id);
    try { sessionStorage.setItem(KEY_STORAGE_TAB, id); } catch {}
  };

  return (
    <StatisticheFiltriProvider>
      <div style={{ fontFamily: FONT }}>
        {sottoTabAttivo !== "confronto" ? (
          <DiarioStatisticheFiltri />
        ) : (
          <div style={{ marginTop: 16 }} />
        )}
        <BarraSottoTab
          attivo={sottoTabAttivo}
          onChange={cambiaSottoTab}
        />
        {sottoTabAttivo === "sintesi" && <DiarioStatisticheSintesi />}
        {sottoTabAttivo === "matrici" && <DiarioStatisticheMatrice />}
        {sottoTabAttivo === "confronto" && <DiarioStatisticheConfrontoStagioni />}
      </div>
    </StatisticheFiltriProvider>
  );
}
